import { useState, useEffect, useContext } from 'react'
import './InquiryTable.css'
import {
  getDocs,
  doc,
  updateDoc,
  collection,
  query,
  where,
  orderBy,
  Timestamp,
} from 'firebase/firestore'
import { db } from '../firebase.config'
import Spinner from '../components/Spinner'
// import InquiryFilter from './InquiryFilter'
import RoleContext from '../context/roleContext'
import { getAuth } from 'firebase/auth'
import dateFormat from 'dateformat'

const InquiryTable = () => {
  const [inquiries, setInquiries] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const auth = getAuth()

  const { role } = useContext(RoleContext)

  useEffect(() => {
    const fetchInquiries = async () => {
      let q
      if (role === 'super-admin') {
        q = query(collection(db, 'inquiries'), orderBy('timestamp', 'desc'))
      } else {
        q = query(
          collection(db, 'inquiries'),
          where('agentId', '==', auth.currentUser.uid),
          orderBy('timestamp', 'desc'),
        )
      }
      await getDocs(q).then((querySnapshot) => {
        const filteredData = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        console.log('Hi')
        setInquiries(filteredData)
        fetchUsers()
      })
    }

    const fetchUsers = async () => {
      await getDocs(collection(db, 'users')).then((querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        setUsers(data)
        setLoading(false)
      })
    }
    fetchInquiries()
  }, [])

  const onChangeAgent = async (e, id) => {
    const user = users.find((user) => user.name === e.target.value)
    const userId = user.id
    const foundIndex = inquiries.findIndex((inquiry) => inquiry.id === id)
    let inquiryId = inquiries[foundIndex].id
    const newInquiries = inquiries.map((inquiry, index) => {
      if (foundIndex === index) {
        return { ...inquiry, agentName: e.target.value, agentId: userId }
      }
      return inquiry
    })

    const inquiryRef = doc(db, 'inquiries', inquiryId)
    await updateDoc(inquiryRef, {
      agentName: e.target.value,
      agentId: userId,
    })
    setInquiries(newInquiries)
  }

  const onChangeStatus = async (e, id) => {
    const foundIndex = inquiries.findIndex((inquiry) => inquiry.id === id)
    let inquiryId = inquiries[foundIndex].id
    const newInquiries = inquiries.map((inquiry, index) => {
      if (foundIndex === index) {
        return { ...inquiry, status: e.target.value }
      }
      return inquiry
    })

    const inquiryRef = doc(db, 'inquiries', inquiryId)
    await updateDoc(inquiryRef, {
      status: e.target.value,
    })
    setInquiries(newInquiries)
  }

  const getFormattedDate = (mytimeStamp) => {
    const timeStamp = new Timestamp(
      mytimeStamp.seconds,
      mytimeStamp.nanoseconds,
    )
    const formattedDate = dateFormat(
      timeStamp.toDate(),
      'dddd, mmmm dS, yyyy, h:MM:ss TT',
    )
    return formattedDate
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <div>
      <div className="container">
        <h1 className="title">INQUIRIES</h1>
        {/* <InquiryFilter /> */}
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Name</th>
              <th>Email</th>
              <th>PhoneNo</th>
              <th>Message</th>
              {role === 'super-admin' && <th className="agent">Agent</th>}
              <th className="status">Status</th>
            </tr>
          </thead>
          <tbody>
            {inquiries.map(
              ({
                id,
                timestamp,
                name,
                email,
                phoneNo,
                message,
                agentName,
                status,
              }) => (
                <tr key={id}>
                  <td>
                    <div className="col" id="time" type="text">
                      {getFormattedDate(timestamp)}
                    </div>
                  </td>
                  <td>
                    <div className="col" id="name" value={name} type="text">
                      {name}{' '}
                    </div>
                  </td>
                  <td>
                    <div className="col" id="email" value={email} type="text">
                      {email}
                    </div>
                  </td>
                  <td>
                    <div
                      className="col"
                      name="phoneNo"
                      type="text"
                      value={phoneNo}
                    >
                      {phoneNo}
                    </div>
                  </td>
                  <td>
                    <div
                      className="col"
                      name="message"
                      type="text"
                      value={message}
                    >
                      {message}
                    </div>
                  </td>
                  {role === 'super-admin' && (
                    <td>
                      {/* <input
                    name="agent"
                    type="text"
                    defaultValue={agent}
                    onChange={(e) => onChangeAgent(e, id)}
                    placeholder="Type Name"
                  /> */}
                      <select
                        className="col"
                        defaultValue={agentName}
                        onChange={(e) => onChangeAgent(e, id)}
                      >
                        <option value={null}>Select an option</option>
                        {users.map((user) => {
                          return (
                            <option key={user.id} value={user.name}>
                              {user.name}
                            </option>
                          )
                        })}
                      </select>
                    </td>
                  )}
                  <td>
                    <select
                      className="col"
                      defaultValue={status}
                      onChange={(e) => onChangeStatus(e, id)}
                    >
                      <option>Select an option</option>
                      <option value="Open">Open</option>
                      <option value="In progress">In progress</option>
                      <option value="Win">Win</option>
                      <option value="Loss">Loss</option>
                    </select>
                  </td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default InquiryTable
